

export default {
  getTask: state => tranksaksiId => state.tranksaksis.find((tranksaksi) => tranksaksi.id === tranksaksiId)
}
